import React from 'react'
import { getRelevantAnswer } from '../../../../../../../../../utils/question.helper'
import SimilarAnswers from './SimilarAnswers'
import { useSelector } from 'react-redux'
import textSubmissionDrawerSelectors from '../../../../../../../../../store/selectors/text-submission-drawer.selectors'
import QuestionRubricCollapse from '../QuestionRubricCollapse'

const SimilarAnswersSection = ({ question, answers }) => {
    const focusedQuestionRubricId = useSelector(textSubmissionDrawerSelectors.focusedQuestionRubricId)
    const questionRubrics = question.questionRubrics || []

    if (questionRubrics.length > 1) {
        return <QuestionRubricCollapse question={question} answers={answers} ContentComponent={SimilarAnswers} />
    }

    return <SimilarAnswers questionRubric={questionRubrics[0]} answer={getRelevantAnswer(answers, question, focusedQuestionRubricId)} />
}

export default SimilarAnswersSection
